import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TeacherCertificateModalStore } from './typings';

const initialState: TeacherCertificateModalStore = {
    isModalOpened: false,
};

const slice = createSlice({
    name: 'TEACHER_CERTIFICATE_MODAL',
    initialState: initialState,
    reducers: {
        toogleModal: (state, action: PayloadAction<{ shouldShowModal: boolean }>) => {
            state.isModalOpened = action.payload.shouldShowModal;
        },
    },
});

export const teacherCertificateModalActions = slice.actions;
export const teacherCertificateModalReducer = slice.reducer;
